import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./ConditionsCard.styled";
import style from "./ConditionsCard.module.scss";
import {FaChevronLeft} from "react-icons/fa6";
import ConditionsPopup from "../conditionsPopup/ConditionsPopup";
import {ConditionsCardProps} from "../../models";
import {useLocation} from "react-router-dom";
const ConditionsCard = ({onConfirm} :ConditionsCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [chosenItems, setChosenItems] = useState<any>([])
    const location = useLocation();
    const openGuaranteeModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    useEffect(() => {
        if (location?.state?.stepTwoForm?.productConditions)
            setChosenItems(location?.state?.stepTwoForm?.productConditions)
    }, [location]);
    return (
    <>        <StyledCard className={'shadow-sm'} onClick={openGuaranteeModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex align={"center"} gap={"small"}>
                   <span>شرایط نگهداری</span>
                </Flex>
                <Flex gap={"small"} align={"center"}>
                    {chosenItems?.length > 0  && <span className={style.icons}>{chosenItems?.length} مورد انتخاب شده </span>}
                    <span> <FaChevronLeft  className={style.icons}/> </span>
                </Flex>

            </Flex>
        </StyledCard>
        <ConditionsPopup open={open} onCansel={onCansel} onConfirm={(form:any) => {
            onConfirm(form)
            setChosenItems(form)
        }}/>
    </>

);
};

export default ConditionsCard;
